module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_troendelag_neg.fe19cf38.png";